// externals

// libraries
import type { CreditDecision, CreditDecisionState, FldLenderDecision } from '@makemydeal/dr-dash-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import type { Reducer } from 'redux';
import { APPLY_CREDIT_DECISION, GET_CREDIT_APP_DATA_SUCCESS } from '../actionTypes/creditDecisionActionTypes';
import {
    GET_LENDER_DECISIONS,
    GET_LENDER_DECISIONS_FAILURE,
    GET_LENDER_DECISIONS_SUCCESS
} from '../actionTypes/fullLenderDecisionsActionTypes';

const { INIT_PENCIL_SUCCESS } = initActionTypes;

export interface InitPencilSuccessPayload {
    creditDecision?: { body?: CreditDecision[] };
    sourcePartnerId?: string;
}

export type CreditDecisionReducerAction =
    | {
          type: typeof INIT_PENCIL_SUCCESS;
          payload: InitPencilSuccessPayload;
      }
    | {
          type: typeof GET_CREDIT_APP_DATA_SUCCESS;
          payload: { data: { creditDecision?: CreditDecision[] } };
      }
    | {
          type: typeof GET_LENDER_DECISIONS_SUCCESS;
          payload: { lenderDecisions?: FldLenderDecision[]; financeMethod?: string };
      }
    | {
          type: typeof APPLY_CREDIT_DECISION;
          payload: CreditDecision;
      }
    | {
          type: typeof GET_LENDER_DECISIONS;
      }
    | {
          type: typeof GET_LENDER_DECISIONS_FAILURE;
      };

export type CreditDecisionReducer = Reducer<CreditDecisionState, CreditDecisionReducerAction>;

const defaultState = {
    decisionsList: [],
    sourcePartnerId: '',
    selectedDecision: {},
    fullLenderDecisions: undefined
};

export const reducer: CreditDecisionReducer = (state = defaultState, action) => {
    switch (action.type) {
        case INIT_PENCIL_SUCCESS: {
            const { payload } = action as { type: typeof INIT_PENCIL_SUCCESS; payload: InitPencilSuccessPayload };
            return {
                ...state,
                sourcePartnerId: payload.sourcePartnerId || '',
                selectedDecision: {}
            };
        }
        case GET_CREDIT_APP_DATA_SUCCESS: {
            const { payload } = action;
            return {
                ...state,
                decisionsList: payload.data.creditDecision || []
            };
        }
        case GET_LENDER_DECISIONS_SUCCESS: {
            const { payload } = action;
            return {
                ...state,
                fullLenderDecisions: {
                    lenderDecisions: payload.lenderDecisions || [],
                    financeMethod: payload.financeMethod || '',
                    isLoadingLenderDecisions: false
                }
            };
        }
        case APPLY_CREDIT_DECISION: {
            const { payload } = action;
            return {
                ...state,
                selectedDecision: payload
            };
        }
        case GET_LENDER_DECISIONS: {
            return {
                ...state,
                fullLenderDecisions: {
                    ...state.fullLenderDecisions,
                    isLoadingLenderDecisions: true
                }
            };
        }

        case GET_LENDER_DECISIONS_FAILURE: {
            return {
                ...state,
                fullLenderDecisions: {
                    ...state.fullLenderDecisions,
                    isLoadingLenderDecisions: false
                }
            };
        }
        default: {
            return state;
        }
    }
};
